import { useFragment } from "react-relay"
import { Tag } from "@/components/ui/tag"
import { cn } from "@/lib/utils"
import { getEpisodeOfCareFragment } from "@/modules/patients/detail/episode-of-care/lib/get-episode-of-care-fragment"
import { EpisodeOfCareFragment$key } from "@/modules/patients/detail/episode-of-care/types/episode-of-care-fragment-type"
import { Country } from "@/modules/patients/services/__generated__/PatientFragment.graphql"

interface EpisodeOfCareActionsProps extends React.ComponentPropsWithoutRef<"div"> {
  episodeOfCareRef: EpisodeOfCareFragment$key
  country: Country
}

const EpisodeOfCareRelatedConditions = ({
  episodeOfCareRef,
  country,
  className,
  ...restProps
}: EpisodeOfCareActionsProps) => {
  const { relatedConditions } = useFragment(getEpisodeOfCareFragment(country), episodeOfCareRef)

  return (
    <div className={cn("flex flex-wrap gap-2", className)} {...restProps} data-testid="related-conditions">
      {relatedConditions.map((v) => (
        <Tag
          key={v.icdDiagnosis.diagnosisCode}
          className="max-w-full"
          type="neutral"
          label={v.icdDiagnosis.text ?? undefined}
          data-testid={v.icdDiagnosis.diagnosisCode}
        />
      ))}
    </div>
  )
}

export { EpisodeOfCareRelatedConditions }
